// [2026-10-30] เลิกใช้ LINE ทั้งเว็บ → ทุกปุ่ม "ติดต่อ" เปิดแชทสด (Javis Live Chat widget ใน public/index.html)
//   openLiveChat(e)        : เปิดหน้าต่างแชทสด (ถ้าสคริปต์แชทยังโหลดไม่เสร็จ จะรอสูงสุด ~5 วิ)
//   installLineToChat()    : ลิงก์ LINE ที่หลงเหลือ (เช่น ข้อความ/แบนเนอร์จากหลังบ้านที่มี line.me / lin.ee) → กดแล้วเปิดแชทสดแทน
import Swal from 'sweetalert2';

export const CHAT_ICON = "data:image/svg+xml;utf8," + encodeURIComponent(
  "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'><defs><linearGradient id='g' x1='0' y1='0' x2='0' y2='1'><stop offset='0' stop-color='#ffe58a'/><stop offset='1' stop-color='#f5b623'/></linearGradient></defs>" +
  "<circle cx='24' cy='24' r='23' fill='url(#g)'/><path d='M13 15h22a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H22l-6 5v-5h-3a3 3 0 0 1-3-3V18a3 3 0 0 1 3-3z' fill='#7a0000'/>" +
  "<circle cx='18' cy='24' r='2.2' fill='#fff'/><circle cx='24' cy='24' r='2.2' fill='#fff'/><circle cx='30' cy='24' r='2.2' fill='#fff'/></svg>");

export function openLiveChat(e) {
  if (e && e.preventDefault) e.preventDefault();
  if (e && e.stopPropagation) e.stopPropagation();
  const tryOpen = () => {
    if (window.JavisChat && typeof window.JavisChat.open === 'function') { window.JavisChat.open(); return true; }
    return false;
  };
  if (tryOpen()) return;
  let n = 0;
  const t = setInterval(() => {
    n++;
    if (tryOpen()) { clearInterval(t); return; }
    if (n >= 25) {
      clearInterval(t);
      Swal.fire({ icon: 'info', title: 'แชทสด', text: 'กำลังเชื่อมต่อแชทสด กรุณาลองใหม่อีกครั้ง', confirmButtonText: 'ตกลง' });
    }
  }, 200);
}

const LINE_RE = /(^|\/\/)(line\.me|lin\.ee|page\.line\.me|liff\.line\.me)\b|^line:\/\//i;
let installed = false;
export function installLineToChat() {
  if (installed || typeof document === 'undefined') return;
  installed = true;
  document.addEventListener('click', (e) => {
    const a = e.target && e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    const href = a.getAttribute('href') || '';
    if (LINE_RE.test(href)) openLiveChat(e);
  }, true);
}
